/*
 * MelonJS Game Engine
 * Copyright (C) 2011 - 2015, Olivier Biot, Jason Oster, Aaron McLeod
 * http://www.melonjs.org
 *
 * a simple debug panel plugin
 * usage : me.plugin.register.defer(this, me.debug.Panel, "debug");
 *
 * you can then use me.plugins.debug.show() or me.plugins.debug.hide()
 * to show or hide the panel, or press respectively the "S" and "H" keys.
 *
 * note :
 * Heap Memory information is available under Chrome when using
 * the "--enable-memory-info" parameter to launch Chrome
 */

(function () {
  // ensure that me.debug is defined
  me.debug = me.debug || {};

  var DEBUG_HEIGHT = 70;

  var Counters = me.Object.extend({
    init : function (stats) {
      this.stats = {};
      this.reset(stats);
    },

    reset : function (stats) {
      var self = this;
      (stats || Object.keys(this.stats)).forEach(function (stat) {
        self.stats[stat] = 0;
      });
    },

    inc : function (stat, value) {
      this.stats[stat] += (value || 1);
    },

    get : function (stat) {
      return this.stats[stat];
    }
  });

  var DebugPanel = me.Renderable.extend({
    /** @private */
    init : function (showKey, hideKey) {
      // call the super constructor
      this._super(me.Renderable, "init", [ 0, 0, me.game.viewport.width, DEBUG_HEIGHT ]);

      // minimum melonJS version expected
      this.version = "3.1.0";

      // to hold the debug options
      // clickable rect area
      this.area = {};

      // Useful counters
      this.counters = new Counters([
        "shapes",
        "sprites",
        "velocity",
        "bounds",
        "children"
      ]);

      this.sensors = {
        front: 0,
        left: 0,
        right: 0
      };

      this.robotPos = {
        x: 0,
        y: 0
      }

      // for z ordering
      // make it ridiculously high
      this.pos.z = Infinity;

      // visibility flag
      this.visible = false;

      // frame update time in ms
      this.frameUpdateTime = 0;

      // frame draw time in ms
      this.frameDrawTime = 0;

      // set the object GUID value
      this.GUID = "debug-" + me.utils.createGUID();

      // set the object entity name
      this.name = "me.debugPanel";

      // persistent
      this.isPersistent = true;

      // a floating object
      this.floating = true;

      // renderable
      this.isRenderable = true;

      // always update, even when not visible
      this.alwaysUpdate = true;

      // WebGL/Canvas compatibility
      this.canvas = me.video.createCanvas(this.width, this.height, true);

      // create a default font, with fixed char width
      this.font_size = 10;
      this.mod = 1;
      if (this.width < 500) {
        this.font_size = 7;
        this.mod = 0.7;
      }
      this.font = new me.Font("courier", this.font_size, "white");

      // clickable areas
      var size = 12 * this.mod;
      this.area.renderHitBox   = new me.Rect(163, 5,  size, size);
      this.area.renderVelocity = new me.Rect(163, 20, size, size);
      this.area.renderQuadTree = new me.Rect(253, 5,  size, size);

      // some internal string/length
      this.help_str    = "(s)how/(h)ide";
      this.help_str_len  = this.font.measureText(me.video.renderer, this.help_str).width;
      this.fps_str_len   = this.font.measureText(me.video.renderer, "00/00 fps").width;
      this.memoryPositionX = 400 * this.mod;

      // enable the FPS counter
      me.debug.displayFPS = true;

      // bind the "S" and "H" keys
      me.input.bindKey(showKey || me.input.KEY.S, "show", false, false);
      me.input.bindKey(hideKey || me.input.KEY.H, "hide", false, false);

      // add some keyboard shortcuts
      var self = this;
      this.keyHandler = me.event.subscribe(me.event.KEYDOWN, function (action) {
        if (action === "show") {
          self.show();
        }
        else if (action === "hide") {
          self.hide();
        }
      });
      me.event.subscribe(me.event.VIEWPORT_ONRESIZE, function (w) {
        self.resize(w, DEBUG_HEIGHT);
      });

      //patch patch patch !
      this.patchSystemFn();
    },

    /**
     * patch system fn to draw debug information
     */
    patchSystemFn : function () {

      // add a few new debug flag (if not yet defined)
      me.debug.renderHitBox   = me.debug.renderHitBox   || me.game.HASH["hitbox"] || false;
      me.debug.renderVelocity = me.debug.renderVelocity || me.game.HASH["velocity"] || false;
      me.debug.renderQuadTree = me.debug.renderQuadTree || me.game.HASH["quadtree"] || false;

      var _this = this;
      var bounds = new me.Rect(0, 0, 0, 0);

      // patch timer.js
      me.plugin.patch(me.timer, "update", function (dt) {
        // call the original me.timer.update function
        this._patched(dt);

        // call the FPS counter
        me.timer.countFPS();
      });

      // patch me.game.update
      me.plugin.patch(me.game, "update", function (dt) {
        var frameUpdateStartTime = window.performance.now();

        this._patched(dt);

        // calculate the update time
        _this.frameUpdateTime = window.performance.now() - frameUpdateStartTime;
      });

      // patch me.game.draw
      me.plugin.patch(me.game, "draw", function () {
        var frameDrawStartTime = window.performance.now();

        _this.counters.reset();
        this._patched();

        // calculate the drawing time
        _this.frameDrawTime = window.performance.now() - frameDrawStartTime;
      });

      // patch sprite.js
      me.plugin.patch(me.Sprite, "draw", function (renderer) {
        // call the original me.Sprite.draw function
        this._patched(renderer);

        // draw the sprite rectangle
        if (me.debug.renderHitBox) {
          var x = -this.anchorPoint.x * this.width;
          var y = -this.anchorPoint.y * this.height;
          
          renderer.save();
          renderer.setColor("green");
          renderer.translate(x, y);
          renderer.strokeRect(this.left, this.top, this.width, this.height);
          _this.counters.inc("sprites");
          renderer.restore();
        }
      });
      
      // patch entities.js
      me.plugin.patch(me.Entity, "draw", function (renderer) {
        // call the original me.Entity.draw function
        this._patched(renderer);

        // check if debug mode is enabled
        if (me.debug.renderHitBox) {
          renderer.save();
          renderer.setLineWidth(1);

          // draw the bounding rect shape
          renderer.setColor("orange");
          bounds.copy(this.getBounds());
          bounds.pos.sub(this.ancestor._absPos);
          renderer.drawShape(bounds);
          _this.counters.inc("bounds");

          // draw all defined shapes
          renderer.setColor("red");
          renderer.translate(this.pos.x, this.pos.y);
          for (var i = this.body.shapes.length, shape; i--, (shape = this.body.shapes[i]);) {
            renderer.drawShape(shape);
            _this.counters.inc("shapes");
          }
          renderer.restore();
        }

        if (me.debug.renderVelocity && (this.body.vel.x || this.body.vel.y)) {
          bounds.copy(this.getBounds());
          bounds.pos.sub(this.ancestor._absPos);
          // draw entity current velocity
          var x = ~~(bounds.pos.x + (bounds.width / 2));
          var y = ~~(bounds.pos.y + (bounds.height / 2));

          renderer.save();
          renderer.setLineWidth(1);

          renderer.setColor("blue");
          renderer.translate(x, y);
          renderer.strokeLine(0, 0, ~~(this.body.vel.x * (bounds.width / 2)), ~~(this.body.vel.y * (bounds.height / 2)));
          _this.counters.inc("velocity");

          renderer.restore();
        }
      });

      me.plugin.patch(me.Entity, "update", function (dt) {
        /* Call the original update function */
        this._patched(dt);
        if(typeof this.sensors !== "undefined") {
          _this.sensors.left = this.sensors.left;
          _this.sensors.right = this.sensors.right;
          _this.sensors.front = this.sensors.front;
          _this.robotPos.x = Math.round(this.pos.x);
          _this.robotPos.y = Math.round(this.pos.y);
        }

      });
      // patch container.js
      me.plugin.patch(me.Container, "draw", function (renderer, rect) {
        // call the original me.Container.draw function
        this._patched(renderer, rect);

        // check if debug mode is enabled

        if (me.debug.renderHitBox) {
          renderer.save();
          renderer.setLineWidth(1);

          // draw the bounding rect shape
          renderer.setColor("orange");
          bounds.copy(this.getBounds());
          if (this.ancestor) {
            bounds.pos.sub(this.ancestor._absPos);
          }
          renderer.drawShape(bounds);
          _this.counters.inc("bounds");

          // draw the children bounding rect shape
          renderer.setColor("purple");
          bounds.copy(this.childBounds);
          if (this.ancestor) {
            bounds.pos.sub(this.ancestor._absPos);
          }
          renderer.drawShape(bounds);
          _this.counters.inc("children");

          renderer.restore();
        }
      });
    },

    /**
     * show the debug panel
     */
    show : function () {
      if (!this.visible) {
        // register a mouse event for the checkboxes
        me.input.registerPointerEvent("pointerdown", this, this.onClick.bind(this));
        // add the debug panel to the game world
        me.game.world.addChild(this, Infinity);
        // mark it as visible
        this.visible = true;
        // force repaint
        me.game.repaint();
      }
    },

    /**
     * hide the debug panel
     */
    hide : function () {
      if (this.visible) {
        // release the mouse event for the checkboxes
        // me.input.releasePointerEvent("pointerdown", this);
        this.canvas.removeEventListener("click", this.onClick.bind(this));
        // remove the debug panel from the game world
        me.game.world.removeChild(this);
        // mark it as invisible
        this.visible = false;
        // force repaint
        me.game.repaint();
      }
    },


    /** @private */
    update : function () {
      if (me.input.isKeyPressed("show")) {
        this.show();
      }
      else if (me.input.isKeyPressed("hide")) {
        this.hide();
      }
      return true;
    },

    /** @private */
    onClick : function (e)  {
      // check the clickable areas
      if (this.area.renderHitBox.containsPoint(e.gameX, e.gameY)) {
        me.debug.renderHitBox = !me.debug.renderHitBox;
      }
      else if (this.area.renderVelocity.containsPoint(e.gameX, e.gameY)) {
        // does nothing for now, since velocity is
        // rendered together with hitboxes (is a global debug flag required?)
        me.debug.renderVelocity = !me.debug.renderVelocity;
      }
      else if (this.area.renderQuadTree.containsPoint(e.gameX, e.gameY)) {
        me.debug.renderQuadTree = !me.debug.renderQuadTree;
      }
      // force repaint
      me.game.repaint();
    },

    /** @private */
    drawQuadTreeNode : function (renderer, node) {
      var bounds = node.bounds;

      // draw the current bounds
      if (node.nodes.length === 0) {
        // cap the alpha value to 0.4 maximum
        var _alpha = (node.objects.length * 0.4) / me.collision.maxChildren;
        if (_alpha > 0.0) {
          renderer.save();
          renderer.setColor("rgba(255,0,0," + _alpha + ")");
          renderer.fillRect(bounds.pos.x, bounds.pos.y, bounds.width, bounds.height);
          renderer.restore();
        }
      }
      else {
        //has subnodes? drawQuadtree them!
        for (var i = 0; i < node.nodes.length; i++) {
          this.drawQuadTreeNode(renderer, node.nodes[i]);
        }
      }
    },

    /** @private */
    drawQuadTree : function (renderer) {
      // save the current globalAlpha value
      var _alpha = renderer.globalAlpha();
      var x = me.game.viewport.pos.x;
      var y = me.game.viewport.pos.y;

      renderer.translate(-x, -y);

      this.drawQuadTreeNode(renderer, me.collision.quadTree);

      renderer.translate(x, y);

      renderer.setGlobalAlpha(_alpha);
    },

    /** @private */
    drawMemoryGraph : function (renderer, endX) {
      if (window.performance && window.performance.memory) {
        var usedHeap  = Number.prototype.round(window.performance.memory.usedJSHeapSize / 1048576, 2);
        var totalHeap =  Number.prototype.round(window.performance.memory.totalJSHeapSize / 1048576, 2);
        var maxLen = ~~(endX - this.memoryPositionX - 5);
        var len = maxLen * (usedHeap / totalHeap);

        renderer.setColor("#0065AD");
        renderer.fillRect(this.memoryPositionX, 0, maxLen, 20);
        renderer.setColor("#3AA4F0");
        renderer.fillRect(this.memoryPositionX + 1, 1, len - 1, 17);

        this.font.draw(renderer, "Heap : " + usedHeap + "/" + totalHeap + " MB", this.memoryPositionX + 5, 5 * this.mod);
      }
      else {
        // Heap Memory information not available
        this.font.draw(renderer, "Heap : ??/?? MB", this.memoryPositionX, 5 * this.mod);
      }
    },

    /** @private */
    draw : function (renderer) {
      renderer.save();

      // draw the QuadTree (before the panel)
      if (me.debug.renderQuadTree === true) {
        this.drawQuadTree(renderer);
      }

      // draw the panel
      renderer.setGlobalAlpha(0.5);
      renderer.setColor("black");
      renderer.fillRect(
        this.left,  this.top,
        this.width, this.height
      );
      renderer.setGlobalAlpha(1.0);

      this.font.draw(renderer, "#objects : " + me.game.world.children.length, 5 * this.mod, 5 * this.mod);
      this.font.draw(renderer, "#draws   : " + me.game.world.drawCount, 5 * this.mod, 20 * this.mod);

      // debug checkboxes
      this.font.draw(renderer, "?hitbox   [" + (me.debug.renderHitBox ? "x" : " ") + "]",   100 * this.mod, 5 * this.mod);
      this.font.draw(renderer, "?velocity [" + (me.debug.renderVelocity ? "x" : " ") + "]", 100 * this.mod, 20 * this.mod);

      this.font.draw(renderer, "?QuadTree [" + (me.debug.renderQuadTree ? "x" : " ") + "]", 190 * this.mod, 5 * this.mod);

      // draw the update duration
      this.font.draw(renderer, "Update : " + this.frameUpdateTime.toFixed(2) + " ms", 285 * this.mod, 5 * this.mod);
      // draw the draw duration
      this.font.draw(renderer, "Draw   : " + this.frameDrawTime.toFixed(2) + " ms", 285 * this.mod, 20 * this.mod);

      // Draw color code hints
      this.font.fillStyle.copy("red");
      this.font.draw(renderer, "Shapes   : " + this.counters.get("shapes"), 5 * this.mod, 35 * this.mod);

      this.font.fillStyle.copy("green");
      this.font.draw(renderer, "Sprites   : " + this.counters.get("sprites"), 100 * this.mod, 35 * this.mod);

      this.font.fillStyle.copy("blue");
      this.font.draw(renderer, "Velocity  : " + this.counters.get("velocity"), 190 * this.mod, 35 * this.mod);

      this.font.fillStyle.copy("orange");
      this.font.draw(renderer, "Bounds : " + this.counters.get("bounds"), 285 * this.mod, 35 * this.mod);

      this.font.fillStyle.copy("purple");
      this.font.draw(renderer, "Children : " + this.counters.get("children"), 400 * this.mod, 35 * this.mod);

      // Reset font style
      this.font.setFont("courier", this.font_size, "white");

      /* Draw sensors */
      this.font.draw(renderer, "Front sensor: " + this.sensors.front, 5 * this.mod, 50 * this.mod);
      this.font.draw(renderer, "Left sensor: " + this.sensors.left, 130 * this.mod, 50 * this.mod);
      this.font.draw(renderer, "Right sensor: " + this.sensors.right, 260 * this.mod, 50 * this.mod);
      this.font.draw(renderer, "Robot pos: (" + this.robotPos.x + ", " + this.robotPos.y + ")", 390 * this.mod, 50 * this.mod);

      // draw the memory heap usage
      var endX = this.width - 25;
      this.drawMemoryGraph(renderer, endX - this.help_str_len);

      // some help string
      this.font.draw(renderer, this.help_str, endX - this.help_str_len, 20 * this.mod);

      //fps counter
      var fps_str = me.timer.fps + "/" + me.sys.fps + " fps";
      this.font.draw(renderer, fps_str, this.width - this.fps_str_len - 5, 5 * this.mod);

      renderer.restore();
    },

    /** @private */
    onDestroyEvent : function () {
      // hide the panel
      this.hide();
      // unbind keys event
      me.input.unbindKey(me.input.KEY.S);
      me.input.unbindKey(me.input.KEY.H);
      me.event.unsubscribe(this.keyHandler);
    }
  });

  /**
   * @class
   * @public
   * @extends me.plugin.Base
   * @memberOf me
   * @constructor
   */
  me.debug.Panel = me.plugin.Base.extend(
  /** @scope me.debug.Panel.prototype */
  {

    /** @private */
    init : function (showKey, hideKey) {
      // call the super constructor
      this._super(me.plugin.Base, "init");

      var panel = new DebugPanel(showKey, hideKey);
      panel.show();
    }
  });

  /*---------------------------------------------------------*/
  // END END END
  /*---------------------------------------------------------*/
})();

(function () {
	me.Line = me.Line.extend({
		intersection : function(aLine) {
	      var aLineX1 = aLine.points[0].x + aLine.pos.x;
	      var aLineY1 = aLine.points[0].y + aLine.pos.y;
	      var aLineX2 = aLine.points[1].x + aLine.pos.x;
	      var aLineY2 = aLine.points[1].y + aLine.pos.y;

	      var thisLineX1 = this.points[0].x + this.pos.x;
	      var thisLineY1 = this.points[0].y + this.pos.y;
	      var thisLineX2 = this.points[1].x + this.pos.x;
	      var thisLineY2 = this.points[1].y + this.pos.y;

	      // denominator = ((line2EndY - line2StartY) * (line1EndX - line1StartX)) - ((line2EndX - line2StartX) * (line1EndY - line1StartY));
	      var denominator = ((aLineY2 - aLineY1) * (thisLineX2 - thisLineX1)) - 
	        ((aLineX2 - aLineX1) * (thisLineY2 - thisLineY1));
	      if (denominator == 0)
	          return null;
	      new me.Vector2d()
	      var a = thisLineY1 - aLineY1;
	      var b = thisLineX1 - aLineX1;
	      var numerator1 = ((aLineX2 - aLineX1) * a) - ((aLineY2 - aLineY1) * b);
	      var numerator2 = ((thisLineX2 - thisLineX1) * a) - ((thisLineY2 - thisLineY1) * b);
	      a = numerator1 / denominator;
	      b = numerator2 / denominator;

	      // if line2 is a segment and line1 is infinite, they intersect if:
	      if ((b > 0 && b < 1) && (a > 0 && a < 1)) {
	        var x = thisLineX1 + (a * (thisLineX2 - thisLineX1));
	        var y = thisLineY1 + (a * (thisLineY2 - thisLineY1));
	        return me.pool.pull("vector", x, y);
	      }
	      // if line1 and line2 are segments, they intersect if both of the above are true
	      return null;
	    }
	});

	me.Body = me.Body.extend({
		getEdgesAsLines : function() {
			var result = [];
			if(this.points.length == 2)
				return [me.pool.pull("line", 0, 0, [this.points[0], this.points[1]])];
			for(var i = 0; i < this.points.length; i++) {
				if(i < this.points.length - 1)
					result.push(me.pool.pull("line", 0, 0, [this.points[i], this.points[i + 1]]));
				else
					result.push(me.pool.pull("line", 0, 0, [this.points[i], this.points[0]]));
			}
			return result;
		}
	});

	me.Entity = me.Entity.extend({
		getBodyEdgesAsLines : function() {
			var result = this.body.getEdgesAsLines();
			/* Get the edges of the shape transformed to world positions */
			for(var i = 0; i < result.length; i++) {
				result[i].pos.x += this.pos.x;
				result[i].pos.y += this.pos.y;
			}
			return result;
		}
	});

})();

/* Game namespace */
var game = {

  // Run on page load.

  onload : function (canvasWrapper) {
    /* 
      0 => running
      1 => paused
      2 => finished
    */
    me.execution = {
      state : 2,
      run : function() { this.state = 0; },
      pause : function() { this.state = 1; },
      finish : function() { this.state = 2; },
      isRunning : function() { return this.state == 0; },
      isPaused : function() { return this.state == 1; },
      hasFinished : function() { return this.state == 2; }
    };
    
    me.game.changeMap = function(mapName) {
      me.game.map = mapName;
      me.state.pause();
      me.state.change(me.state.PLAY);
      me.state.resume();
    }

    // Initialize the video.
    if (!me.video.init(640, 640, {wrapper : canvasWrapper, antiAlias: true})) {
      alert("Your browser does not support HTML5 canvas.");
      return;
    }

    if (me.game.HASH["debug"]) {
        window.onReady(function () {
            me.plugin.register.defer(this, me.debug.Panel, "debug", me.input.KEY.V);
        });
    }

    me.game.HUD = {
      HUDContainer : null,
      enabled : false,
      enableHUD : function() {
        this.enabled = true;
        var robotEntity = me.game.world.getChildByProp("name", "robot")[0];
        this.HUDContainer = me.pool.pull("HUDContainer", robotEntity);
        me.game.world.addChild(this.HUDContainer);
      },
      disableHUD : function() {
        this.enabled = false;
        me.game.world.removeChild(this.HUDContainer);
      }
    };

    // Set a callback to run when loading is complete.
    me.loader.onload = this.loaded.bind(this);

    // Load the resources.
    me.loader.preload(game.resources);

    // Initialize melonJS and display a loading screen.
    me.state.set(me.state.LOADING, new game.CustomLoadingScreen());
    me.state.change(me.state.LOADING);
  },

  // Run on game resources loaded.
  loaded : function () {
    /* Set the map to be loaded */
    me.game.map = "area03";

    me.state.set(me.state.PLAY, new game.PlayScreen());

    /* Add our player entity in the entity pool */
    me.pool.register("mainPlayer", game.PlayerEntity);

    /* HUD Container */
    me.pool.register("HUDContainer", game.HUD.Container, true);
    me.pool.register("HUDBackground", game.HUD.Background, true);
    me.pool.register("HUDRobotPosition", game.HUD.RobotPosition, true);
    me.pool.register("HUDRobotSensors", game.HUD.RobotSensors, true);
    me.pool.register("HUDRobotShapes", game.HUD.RobotShapes, true);


    me.pool.register("worldEntity", game.WorldFrameEntity);
    me.pool.register("line", me.Line, true);
    me.pool.register("vector", me.Vector2d, true);

    // Start the game.
    me.state.change(me.state.PLAY);
  }
};

/**
 * a HUD container and child items
 */

game.HUD = game.HUD || {};


game.HUD.Container = me.Container.extend({
  init : function(robotEntity) {
    this._super(me.Container, 'init');
    /* Make sure we follow the viewport */
    this.floating = true;
    /* Make sure our object is always draw first */
    this.z = Infinity;
    this.name = "HUD";

    this.robotEntity = robotEntity;
    this.addChild(me.pool.pull("HUDBackground", 0, 0, me.game.viewport.width, 50));
    this.addChild(me.pool.pull("HUDRobotPosition", 10, 5, this.robotEntity.pos));
    this.addChild(me.pool.pull("HUDRobotSensors", 10, 25, this.robotEntity.sensors));
    this.addChild(me.pool.pull("HUDRobotShapes", this.robotEntity));
    }
});

game.HUD.RobotSensors = me.Renderable.extend({
  init : function(x, y, sensors) {
    this._super(me.Renderable, 'init', [x, y, 10, 10]);
    this.sensors = sensors;
    this.font = new me.Font("courier", 14, "white");
  },

  update : function () {
    return true;
  },

  draw : function (renderer) {
    this.font.draw(renderer, "Sensor izquierdo: " + this.sensors.left, 
      this.pos.x, 
      this.pos.y);

    this.font.draw(renderer, "Sensor derecho: " + this.sensors.right, 
      this.pos.x + 240, 
      this.pos.y);

    this.font.draw(renderer, "Sensor frontal: " + this.sensors.front, 
      this.pos.x + 460,
      this.pos.y);
  }
});


game.HUD.RobotPosition = me.Renderable.extend({
  init : function(x, y, robotPosition) {
    this._super(me.Renderable, 'init', [x, y, 10, 10]);
    this.robotPosition = robotPosition;
    this.localRobotPosition = { x : 0, y : 0 };
    this.font = new me.Font("courier", 14, "white");
  },

  update : function () {
    /* Update only if the position changed */
    if(this.robotPosition.x != this.localRobotPosition.x ||
      this.robotPosition.y != this.localRobotPosition.y) {
      this.localRobotPosition.x = Math.round(this.robotPosition.x);
      this.localRobotPosition.y = Math.round(this.robotPosition.y);
      return true;
    }
    return false;
  },

  draw : function (renderer) {
    var text = "Posición del robot: (" + this.localRobotPosition.x + ", " + this.localRobotPosition.y + ")";
    this.font.draw(renderer, text, this.pos.x + 2, this.pos.y);
  }
});

game.HUD.RobotShapes = me.Renderable.extend({
  init : function(robotEntity) {
    this._super(me.Renderable, 'init', [robotEntity.pos.x, robotEntity.pos.y, 10, 10]);
    this.localRobotPosition = { x : 0, y : 0, angle: 0.0 };
    this.robotEntity = robotEntity;
  },

  update : function() {

    /* Only update if the position or the angle changed */
    if(this.localRobotPosition.x != this.robotEntity.pos.x ||
      this.localRobotPosition.y != this.robotEntity.pos.y ||
      this.localRobotPosition.angle != this.robotEntity.renderable.angle) {
      this.localRobotPosition.x = this.robotEntity.pos.x;
      this.localRobotPosition.y = this.robotEntity.pos.y;
      this.localRobotPosition.angle = this.robotEntity.renderable.angle;
      return true;
    }
    return false;
  },

  draw : function(renderer) {
    renderer.save();
    renderer.setLineWidth(1.5);
    /* Draw all shapes */
    renderer.setColor("red");
    renderer.translate(this.localRobotPosition.x - me.game.viewport.pos.x, 
      this.localRobotPosition.y - me.game.viewport.pos.y);
    for (var i = this.robotEntity.body.shapes.length - 1, 
      shape; i--, (shape = this.robotEntity.body.shapes[i]);) {
      renderer.drawShape(shape);
    }
    renderer.restore();
  }

});

game.HUD.Background = me.Renderable.extend({
  init : function(x, y, width, height) {
      this._super(me.Renderable, 'init', [x, y, width, height]);
      this.width = width;
      this.height = height;
  },

  draw : function(renderer) {
      renderer.setGlobalAlpha(0.5);
      renderer.setColor("black");
      renderer.fillRect(
          this.pos.x,  this.pos.y,
          this.width, this.height
      );
      renderer.setGlobalAlpha(1);
  }
});

/**
 * Player Entity
 */
game.PlayerEntity = me.Entity.extend({
  /* -----
  
  constructor
  
  ------ */ 
  init: function(x, y, settings) {
    // call the constructor
    settings.name = "robot"
    this._super(me.Entity, 'init', [x, y, settings]);


    this.renderable.width = this.width;
    this.renderable.height = this.height;

    /* Get current level */
    var currentLevel = me.levelDirector.getCurrentLevel();

    /* Get current level width and height*/
    this.currentLevelWidth = (currentLevel.cols * currentLevel.tilewidth);
    this.currentLevelHeight = (currentLevel.rows * currentLevel.tileheight);

    this.tracer = {
      enabled : false,
    };

    /* Creating the tracer canvas to draw the robot's movements */
    this.traceCanvas = me.video.createCanvas(this.currentLevelWidth, this.currentLevelHeight, true);
    this.traceCanvas.getContext("2d").clearRect(0, 0, this.currentLevelWidth, this.currentLevelHeight);
    this.traceRenderer = new me.CanvasRenderer(this.traceCanvas, me.game.viewport.width, me.game.viewport.height);
    this.traceRenderer.setColor("#000000");

    /* Set the display to follow our position on both axis (in case the map is too big) */
    me.game.viewport.follow(this.pos, me.game.viewport.AXIS.BOTH);

    /* Ensure the player is updated even when outside of the viewport */
    this.alwaysUpdate = true;
 
    /* Defines the standing animation (using the first frame) */
    this.renderable.addAnimation("unique",  [0]);

    /* Set the unique animation to be rendered */
    this.renderable.setCurrentAnimation("unique");

    /* Defines the map limits */
    this.maxX = this.currentLevelWidth - (this.width / 2) - 0.1;
    this.maxY = this.currentLevelHeight - (this.height / 2) - 0.1;
    this.minX = this.width / 2;
    this.minY = this.height / 2;

    /* Range of detection */
    this.sensorRange = 50;

    this.sensors = {
      front: this.sensorRange,
      left: this.sensorRange,
      right: this.sensorRange
    };

    /* As our robot is round, make its shape to be an ellipse */
    this.body.shapes[0] = new me.Ellipse(0, 0, this.width, this.width);

    /* Shapes for the sensors */
    this.body.shapes[1] = new me.Line(0, this.width / 2, 
      [new me.Vector2d(0,0), new me.Vector2d(0, this.sensorRange)]);
    this.body.shapes[2] = new me.Line(0, - this.width / 2, 
      [new me.Vector2d(0,0), new me.Vector2d(0, - this.sensorRange)]);
    this.body.shapes[3] = new me.Line(this.width / 2, 0, 
      [new me.Vector2d(0,0), new me.Vector2d(this.sensorRange, 0)]);
    this.body.shapes[4] = new me.Line(- this.width / 2, 0, 
      [new me.Vector2d(0,0), new me.Vector2d(- this.sensorRange, 0)]);
    this.body.updateBounds();

    /* Distance between the center of the two wheels, 30 pixels */
    this.l = 30;
    this.wheelRadious = 5;

    this.maxAngularVel = 16 * Math.PI;
    this.minAngularVel = -16 * Math.PI;
    this.maxNumericalVelocity = 100;
    this.minNumericalVelocity = -100;

    this.firstUpdate = true;
  },

  mapValue : function(value, out_min, out_max, in_min, in_max) {
    return (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
  },

  /* http://planning.cs.uiuc.edu/node659.html */
  moveRobot : function(leftMotorVelocity, rightMotorVelocity, time) {
    /* Convert numerical velocity to angular velocity */
    leftMotorVelocity = time * this.mapValue(leftMotorVelocity, 
      this.minAngularVel, this.maxAngularVel, this.minNumericalVelocity, this.maxNumericalVelocity);
    rightMotorVelocity = time * this.mapValue(rightMotorVelocity,
      this.minAngularVel, this.maxAngularVel, this.minNumericalVelocity, this.maxNumericalVelocity);

    var deltaAngle = (this.wheelRadious/this.l) * (leftMotorVelocity - rightMotorVelocity);
    this.pos.x += (this.wheelRadious/2)*(leftMotorVelocity + rightMotorVelocity)*Math.cos(this.renderable.angle);
    this.pos.y += (this.wheelRadious/2)*(leftMotorVelocity + rightMotorVelocity)*Math.sin(this.renderable.angle);
    this.renderable.angle += deltaAngle;

    for(i=1; i<this.body.shapes.length; i++) {
      this.body.shapes[i].rotate(deltaAngle);
      old_x = this.body.shapes[i].pos.x;
      old_y = this.body.shapes[i].pos.y;
      this.body.shapes[i].pos.x = Math.cos(deltaAngle) * (old_x-0) - Math.sin(deltaAngle) * (old_y-0) + 0;
      this.body.shapes[i].pos.y = Math.sin(deltaAngle) * (old_x-0) + Math.cos(deltaAngle) * (old_y-0) + 0;
    }
  },

  /* Extends draw function to draw the tracing */
  draw: function(renderer) {
    if(this.tracer.enabled)
      this.traceRenderer.fillArc(this.pos.x, this.pos.y - 6, 6, 0, 2*Math.PI);
    renderer.drawImage(this.traceCanvas, 0, 0);

    this._super(me.Entity, 'draw', [renderer]);
  },

  /* -----
 
  update the player pos
 
  ------ */
  update: function(dt) {
    this._super(me.Entity, 'update', [dt]);
    /* Fixes incorrect sensors when loaded */
    if(this.firstUpdate) {
      me.collision.check(this);
      this.firstUpdate = false;
    }

    if(me.interpreter !== null && !me.execution.hasFinished()) {
      /* If the instructions waiting to be excecuted are lower than 1000 */
      if(me.interpreter.robotInstructions.length < 1000) {
        /* Do 10 steps with the interpreter */
        for (var i = 0; i < 10; i++) {
          /* If we don't have instructions to excecute and the interpreter is marked as completed
            excecute the interpreter's onCompleted function.
           */
          if(me.interpreter.step() === false && me.interpreter.robotInstructions.length === 0) {
            me.execution.finish();
            me.execution.onCompleted();
            break;
          }
        }
      }

      if(me.interpreter.robotInstructions.length > 0) {
        /* If it's not paused and we have instructions to execute, excecute them */
        if(me.interpreter.robotInstructions.length > 0 && !me.execution.isPaused()) {
          var instruction = me.interpreter.robotInstructions[0];
          switch(instruction.action) {
            case 'motor':
              var duration = instruction.duration;
              var leftWheel = instruction.leftWheel;
              var rightWheel = instruction.rightWheel;

              this.moveRobot(leftWheel, rightWheel, (dt / 1000));

              instruction.duration -= dt / 1000;
              if(instruction.duration <= 0) {
                me.interpreter.robotInstructions.shift();
              }

              break;
            case 'tracer_status':
              this.tracer.enabled = instruction.enabled.data;
              me.interpreter.robotInstructions.shift();
              break;
            case 'tracer_colour':
              this.traceRenderer.setColor(instruction.colour.data);
              me.interpreter.robotInstructions.shift();
              break;
            case 'sensor':
              instruction.sensorResultCallback(
                me.interpreter.createPrimitive(this.sensors[instruction.sensorName.data])
              );
              me.interpreter.robotInstructions.shift();
              break;
          }
        }
      }
    }

    /* Sensor's settings */
    this.sensors.left = this.sensorRange;
    this.sensors.right = this.sensorRange;
    this.sensors.front = this.sensorRange;

    /* Limits checking */
    if(this.pos.x <= this.minX) {
      this.pos.x = this.minX;
    }
    else if(this.pos.x >= this.maxX) {
      this.pos.x = this.maxX;
    }

    if(this.pos.y <= this.minY) {
      this.pos.y = this.minY + 0.10;
    }
    else if(this.pos.y >= this.maxY) {
      this.pos.y = this.maxY;
    }

    /* Adding collision */
    me.collision.check(this);

    return true;

  },
   /**
   * colision handler
   * (called when colliding with other objects)
   */
  onCollision : function (response) {
    /* If the colliding shape belongs to the robot, do a normal collision */
    if(response.indexShapeA === 0 || typeof response.indexShapeA === "undefined") {
      this.pos.sub(response.overlapV);
      return true;
    }

    /* Create a copy of the sensor's range line and positionate it into the level */
    var myLine = me.pool.pull("line", 
      response.a.body.shapes[response.indexShapeA].pos.x + response.a.pos.x, 
      response.a.body.shapes[response.indexShapeA].pos.y + response.a.pos.y,
      [response.a.body.shapes[response.indexShapeA].points[0], 
        response.a.body.shapes[response.indexShapeA].points[1]]);

    /* Get a copy of the line's starting point */
    var startPoint = me.pool.pull("vector", myLine.pos.x, myLine.pos.y);

    /* Get all edges of the entity beeing touched by the sensor line */
    var edges = response.b.getBodyEdgesAsLines();

    /* 
     Calculate the minium distance between the starting point and 
     the point of intersection between the sensor line and the entity
     edges. 
    */
    var minDistance = Number.MAX_SAFE_INTEGER;
    for (var i = 0; i < edges.length; i++) {
      var intersect = myLine.intersection(edges[i]);
      me.pool.push(edges[i]);
      if(intersect !== null) {
        var distance = Math.round(startPoint.distance(intersect));
        if(distance < minDistance)
          minDistance = distance;
        me.pool.push(intersect);
      }
    }

     /* Set the sensor's values */
    switch(response.indexShapeA) {
      case 1:
        response.a.sensors.right = minDistance;
        break;
      case 2:
        response.a.sensors.left = minDistance;
        break;
      case 3:
        response.a.sensors.front = minDistance;
        break;
     }

    /* Return elements to the pool */
    me.pool.push(myLine);
    me.pool.push(startPoint);

    return false;
  }
});

game.WorldFrameEntity = me.Entity.extend({
  init: function() {
    settings = {
      name : "worldEntity",
      width : me.game.viewport.width,
      height : me.game.viewport.height
    };
    this._super(me.Entity, 'init', [0, 0, settings]);

    var actualMap = me.levelDirector.getCurrentLevel();

    this.mapWidth = actualMap.cols * actualMap.tilewidth;
    this.mapHeight = actualMap.rows * actualMap.tileheight;

    /* Top line */
    this.body.shapes[0] = new me.Line(0, 0, [new me.Vector2d(0, 0), 
      new me.Vector2d(this.mapWidth, 0)]);
    /* Left line */
    this.body.shapes[1] = new me.Line(0, 0, [new me.Vector2d(0, 0), 
      new me.Vector2d(0, this.mapHeight)]);
    /* Right line */
    this.body.shapes[2] = new me.Line(0, 0, [new me.Vector2d(this.mapWidth, 0), 
      new me.Vector2d(this.mapWidth, this.mapHeight)]);
    /* Bottom line */
    this.body.shapes[3] = new me.Line(0, 0, [new me.Vector2d(0, this.mapHeight), 
      new me.Vector2d(this.mapWidth, this.mapHeight)]);

    this.body.updateBounds();
  }

});
var ProgressBar = me.Renderable.extend({

    init: function (v, w, h) {
        this._super(me.Renderable, "init", [v.x, v.y, w, h]);
        // flag to know if we need to refresh the display
        this.invalidate = false;

        // default progress bar height
        this.barHeight = 4;

        // current progress
        this.progress = 0;
    },

    // make sure the screen is refreshed every frame
    onProgressUpdate : function (progress) {
        this.progress = ~~(progress * this.width);
        this.invalidate = true;
    },

    // make sure the screen is refreshed every frame
    update : function () {
        if (this.invalidate === true) {
            // clear the flag
            this.invalidate = false;
            // and return true
            return true;
        }
        // else return false
        return false;
    },

     // draw function
    draw : function (renderer) {
        // draw the progress bar
        renderer.setColor("black");
        renderer.fillRect(0, (this.height / 2) - (this.barHeight / 2), this.width, this.barHeight);

        renderer.setColor("#286090");
        renderer.fillRect(0, (this.height / 2) - (this.barHeight / 2), this.progress, this.barHeight);
    }
});

/**
 * a default loading screen
 * @memberOf me
 * @ignore
 * @constructor
 */

game.logoScreen = me.Sprite.extend({
   init : function (x, y) {
    var image = me.loader.getImage("DC_small");
    this._super(me.Sprite, "init", [x, y - image.height, { image : image }]);
   }
 });

game.CustomLoadingScreen = me.ScreenObject.extend({
    // call when the loader is resetted
    onResetEvent : function () {
        // background color
        me.game.world.addChild(new me.ColorLayer("background", "#FFFFFF", 0), 0);

        // progress bar
        var progressBar = new ProgressBar(
            new me.Vector2d(),
            me.video.renderer.getWidth(),
            me.video.renderer.getHeight()
        );

        var logo = new game.logoScreen((me.game.viewport.width / 2), (me.game.viewport.height / 2));

        this.loaderHdlr = me.event.subscribe(
            me.event.LOADER_PROGRESS,
            progressBar.onProgressUpdate.bind(progressBar)
        );

        this.resizeHdlr = me.event.subscribe(
            me.event.VIEWPORT_ONRESIZE,
            progressBar.resize.bind(progressBar)
        );

        me.game.world.addChild(progressBar, 2);
        me.game.world.addChild(logo, 1);
    },

    // destroy object at end of loading
    onDestroyEvent : function () {
        // cancel the callback
        me.event.unsubscribe(this.loaderHdlr);
        me.event.unsubscribe(this.resizeHdlr);
        this.loaderHdlr = this.resizeHdlr = null;
    }
});
game.PlayScreen = me.ScreenObject.extend({
  onResetEvent: function() {
    /* Load level */
    me.levelDirector.loadLevel(me.game.map);

    var robotEntity = me.game.world.getChildByProp("name", "robot")[0];

    /* Add the world entity */
    me.game.world.addChild(me.pool.pull("worldEntity"));

    /* Add the HUD */
    if(me.game.HUD.enabled) {
      me.game.HUD.HUDContainer = me.pool.pull("HUDContainer", robotEntity);
      me.game.world.addChild(me.game.HUD.HUDContainer);
    }
  },

    /**
     * Action to perform when leaving this screen (state change)
     */
  onDestroyEvent: function() {
  }
});
